import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from './FetchData';

export function initiateRaster(deviceId, body, abortController) {
  const auth = window.__APP_AUTH;
  const url = apiConfig.cmServiceInitiateRaster(deviceId);
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  return fetchdata(url, { headers, method: 'POST', body: JSON.stringify(body) }, true, abortController.current)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}

export function getInitiateRasterStatus(url, abortProgressController) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  return fetchdata(url, { headers, method: 'GET' }, true, abortProgressController.current)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
